import axios from 'axios'
import {Message} from 'element-ui'


//创建一个 axios 实例
const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 5000,  // request timeout
});

// 请求拦截
instance.interceptors.request.use(config => {
        let token = localStorage.getItem('token');
        token && (config.headers['Access-Token'] = token);
        return config;
    },
    error => {
        return Promise.reject(error)
    }
);

// 响应拦截
instance.interceptors.response.use(
    response => {
        if (response.data.error) {
            Message.error(response.data.error);
            return Promise.reject(response.data.error);
        }
        return response
    },
    error => {
        return Promise.reject(error)  //error.response.status
    }
);

export default instance
